// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3QGDW","list":"BalanceDue_list__3kerw","listRow":"BalanceDue_listRow__yyRiP","total":"BalanceDue_total__3zJDD"};